"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _antd = require("antd");
var _help = _interopRequireDefault(require("../help/help.js"));
require("./label-container.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class LabelContainer extends _react.default.Component {
  render() {
    const {
      children,
      className,
      helpText,
      actionLabel,
      actionDisabled,
      actionMenu,
      actionMenuVisible,
      onActionMenuVisibleChange,
      onActionClick,
      style
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('label-container', className),
      style: style
    }, children, helpText && /*#__PURE__*/_react.default.createElement(_help.default, {
      text: helpText
    }), actionLabel && !actionMenu && /*#__PURE__*/_react.default.createElement(_antd.Button, {
      className: "label-action",
      type: "link",
      size: "small",
      disabled: actionDisabled,
      onClick: onActionClick
    }, actionLabel), actionLabel && actionMenu && /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
      trigger: ['click'],
      open: actionMenuVisible,
      onOpenChange: onActionMenuVisibleChange,
      overlay: actionMenu
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      className: "label-action",
      type: "link",
      size: "small",
      disabled: actionDisabled,
      onClick: onActionClick
    }, actionLabel)));
  }
}
exports.default = LabelContainer;
//# sourceMappingURL=label-container.js.map